/* eslint-disable */
import IconButton from "@material-ui/core/IconButton";
import DeleteFilterTabDialog from "@saleor/components/DeleteFilterTabDialog";
import SaveFilterTabDialog, {
  SaveFilterTabDialogFormData
} from "@saleor/components/SaveFilterTabDialog";
import { PAGINATE_BY } from "@saleor/config";
import { configurationMenuUrl } from "@saleor/configuration";
import EmailTemplatePage from "@saleor/emailTemplate/components/EmailTemplatePage";
import { useEmailSettingsDefaultCreateMutation } from "@saleor/emailTemplate/mutations";
import { useEmailSettingsListQuery } from "@saleor/emailTemplate/queries";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginator, {
  createPaginationState
} from "@saleor/hooks/usePaginator";
import useShop from "@saleor/hooks/useShop";
import { maybe } from "@saleor/misc";
import {
  rotaryListUrl,
  RotaryListUrlDialog,
  RotaryListUrlQueryParams,
  emailTemplateUrl
} from "@saleor/emailTemplate/urls";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import createFilterHandlers from "@saleor/utils/handlers/filterHandlers";
import createSortHandler from "@saleor/utils/handlers/sortHandler";
import { getSortParams } from "@saleor/utils/sort";
import React from "react";
import { useIntl } from "react-intl";

import {
  areFiltersApplied,
  deleteFilterTab,
  getActiveFilters,
  getFilterOpts,
  getFilterQueryParam,
  getFilterTabs,
  saveFilterTab
} from "./filters";

interface RotaryListProps {
  params: RotaryListUrlQueryParams;
}
const RotaryList: React.FC<RotaryListProps> = ({ params }) => {
  const navigate = useNavigator();
  const paginate = usePaginator();
  const notify = useNotifier();
  const shop = useShop();

  const { isSelected, listElements, reset, toggle, toggleAll } = useBulkActions(
    params.ids
  );
  const intl = useIntl();

  const paginationState = createPaginationState(PAGINATE_BY, params);
  const queryVariables = React.useMemo(
    () => ({
      ...paginationState
    }),
    [params]
  );

  const tabs = getFilterTabs();

  const { data, loading, refetch } = useEmailSettingsListQuery({
    variables: queryVariables
  });

  const currentTab =
    params.activeTab === undefined
      ? areFiltersApplied(params)
        ? tabs.length + 1
        : 0
      : parseInt(params.activeTab, 0);

  const [openModal, closeModal] = createDialogActionHandlers<
    RotaryListUrlDialog,
    RotaryListUrlQueryParams
  >(navigate, rotaryListUrl, params);
  const [
    changeFilters,
    resetFilters,
    handleSearchChange
  ] = createFilterHandlers({
    cleanupFn: reset,
    createUrl: rotaryListUrl,
    getFilterQueryParam,
    navigate,
    params
  });
  const handleTabChange = (tab: number) => {
    reset();
    navigate(
      rotaryListUrl({
        activeTab: tab.toString(),
        ...getFilterTabs()[tab - 1].data
      })
    );
  };
  const handleTabDelete = () => {
    deleteFilterTab(currentTab);
    reset();
    navigate(rotaryListUrl());
  };

  const handleTabSave = (data: SaveFilterTabDialogFormData) => {
    saveFilterTab(data.name, getActiveFilters(params));
    handleTabChange(tabs.length + 1);
  };
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    maybe(() => data.emailSettings.pageInfo),
    paginationState,
    params
  );
  const handleSort = createSortHandler(navigate, rotaryListUrl, params);
  const currencySymbol = maybe(() => shop.defaultCurrency, "USD");

  // const [rotaryBulkDelete, rotaryBulkDeleteOpts] = useRotaryBulkDeleteMutation({
  //   onCompleted: data => {
  //     if (data.rotaryBulkDelete.errors.length === 0) {
  //       closeModal();
  //       notify({
  //         status: "success",
  //         text: intl.formatMessage({
  //           defaultMessage: "Rotary successfully delete",
  //           description: "deleted multiple Rotary"
  //         })
  //       });
  //       reset();
  //       refetch();
  //     }
  //   }
  // });
  const [emailCreate] = useEmailSettingsDefaultCreateMutation({
    onCompleted: data => {
      if (data.emailSettingsDefaultCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "email successfully create",
            description: "email successfully create"
          })
        });
        refetch();
      }
    }
  });
  return (
    <>
      <EmailTemplatePage
        emailSettings={maybe(() =>
          data?.emailSettings?.edges.map(edge => edge.node)
        )}
        currencySymbol={currencySymbol}
        currentTab={currentTab}
        disabled={loading}
        filterOpts={getFilterOpts(params)}
        initialSearch={params.query || ""}
        isChecked={isSelected}
        onAdd={emailCreate}
        onAll={resetFilters}
        onBack={() => navigate(configurationMenuUrl)}
        onFilterChange={changeFilters}
        onNextPage={loadNextPage}
        onPreviousPage={loadPreviousPage}
        onRowClick={id => () => navigate(emailTemplateUrl(id))}
        onSearchChange={handleSearchChange}
        onSort={handleSort}
        onTabChange={handleTabChange}
        onTabDelete={() => openModal("delete-search")}
        onTabSave={() => openModal("save-search")}
        pageInfo={pageInfo}
        selected={listElements.length}
        sort={getSortParams(params)}
        tabs={tabs.map(tab => tab.name)}
        toggle={toggle}
        toggleAll={toggleAll}
        toolbar={<IconButton color="primary"></IconButton>}
      ></EmailTemplatePage>
      {/* <RotaryBulkDeleteDialog
        confirmButtonState={rotaryBulkDeleteOpts.status}
        open={params.action === "remove" && maybe(() => params.ids.length > 0)}
        onConfirm={() => rotaryBulkDelete({ variables: { ids: params.ids } })}
        onClose={closeModal}
        quantity={maybe(() => params.ids.length)}
      /> */}
      <SaveFilterTabDialog
        open={params.action === "save-search"}
        confirmButtonState="default"
        onClose={closeModal}
        onSubmit={handleTabSave}
      />
      <DeleteFilterTabDialog
        open={params.action === "delete-search"}
        confirmButtonState="default"
        onClose={closeModal}
        onSubmit={handleTabDelete}
        tabName={maybe(() => tabs[currentTab - 1].name, "...")}
      />
    </>
  );
};
export default RotaryList;
